import { DirectTalkType } from "@/direct-restapi-types";

export type Talk = DirectTalkType & {
    display_name: string,
    user_count_str: string,
    show_open_talk_icon: boolean,
}

export const normalizeTalk = ( talk: DirectTalkType, userId: string, isEnableOpenTalk: boolean ): Talk => {

    // 画面表示用トーク名
    let displayName;
    if ( talk.name ) {
        displayName = talk.name;
    } else {
        // トーク名が設定されていない場合
        // ・自分を除き、参加者の名前を "," で繋ぐ
        // ・自分以外誰も居ない場合は「(トークメンバーなし)」
        const names: string[] = [];
        talk.users?.forEach( user => {
            if ( user.user_id_str != userId ) {
                names.push( user.name );
            }
        });

        displayName = 0 < names.length ? names.join(", ") : "(トークメンバーなし)";
    }

    // 参加者数
    const userCountStr = talk.type == "group" ? `(${talk.users.length})` : "";

    // オープントークアイコン表示
    const showOpenTalkIcon = isEnableOpenTalk && talk.settings?.is_open == true;

    return {
        ...talk,
        display_name: displayName,
        user_count_str: userCountStr,
        show_open_talk_icon: showOpenTalkIcon,
    }
}

export const TALK_NONE: Partial<Talk> = {
    talk_id_str: "",
    display_name: "なし",
    user_count_str: "",
}
